import React, { useCallback, ReactElement } from 'react';
import classNames from 'classnames';
import logo from 'assets/icons/global/logo.svg';
import Image from 'atomic/image';
import Search from 'layouts/header/search/search';
import useToggle from 'hooks/use-toggle';
import Icon from 'atomic/icon';
import MenuMobile from 'modules/shared/layout/menu/menu-mobile';
import MenuOverlay from 'modules/shared/layout/menu/menu-overlay/menu-overlay';
import { useScrollLock } from 'hooks/use-scroll-lock';
import { useSelector } from '@ecommerce/nest-ssr/common';
import MenuInterface from 'modules/shared/layout/menu/interfaces/menu.interface';
import Portal from 'components/portal/portal';
import { PageProps } from 'interfaces/page-props';
import { getLogoAlt, getLogoTitle } from 'layouts/header/helpers/get-properties-title';

import './header.mobile.scss';

const HeaderMobile: React.FC = () => {
    const menuItemsTree = useSelector((state: { menuItemsTree: MenuInterface[]; }) => state.menuItemsTree ?? []);
    const pageUrl = useSelector((state: PageProps) => state.pageUrl);
    const [isOpenSearch, searchState] = useToggle();
    const [isOpenMenu, menuState] = useToggle();
    const { lock, unlock } = useScrollLock();

    const openMenu = (): void => {
        lock();
        onCloseSearch();
        menuState.setToggleState(true);
    };

    const onCloseMenu = useCallback(() => {
        unlock();
        menuState.setToggleState(false);
    }, [unlock, menuState]);

    const onOpenSearch = (): void => {
        onCloseMenu();
        searchState.setToggleState(true);
    };

    const onCloseSearch = (): void => {
        searchState.setToggleState(false);
    };

    const Logo = (): ReactElement => (
        <Image
            src={logo}
            alt={getLogoAlt(pageUrl)}
            width={90}
            height={30}
            show={true}
            loading={'eager'}
        />
    );

    return (
        <>
            <header className="header-container" data-section="header">
                <div className="header">
                    <div className="header__partial">
                        <button
                            className="header__menu"
                            type="button"
                            onClick={openMenu}
                            aria-label="Icon Menu"
                        >
                            <Icon name="align-justify" aria-hidden="true" color="white" />
                        </button>
                        <div className="header__wrapper">
                            <a
                                href="/"
                                className={classNames('header__logo', {
                                    'header__logo--hidden': isOpenSearch
                                })}
                                rel="start"
                                aria-label="logo"
                                title={getLogoTitle(pageUrl)}
                            >
                                {pageUrl === '/'
                                    ? (
                                        <h1>
                                            <Logo />
                                        </h1>
                                    )
                                    : (
                                        <Logo />
                                    )
                                }
                            </a>
                            <div
                                className={classNames('header__search', {
                                    'header__search--close': !isOpenSearch
                                })}
                            >
                                <Search onFocusSearch={onOpenSearch} onBlurSearch={onCloseSearch} />
                            </div>
                        </div>
                    </div>
                    <Portal>
                        <MenuMobile
                            isOpen={isOpenMenu}
                            onClose={onCloseMenu}
                            title="Wszystkie kategorie"
                            menuList={menuItemsTree}
                            isCustomTop={true}
                            maxListItems={12}
                            level={1}
                        />
                    </Portal>
                    {isOpenMenu && <MenuOverlay onClose={onCloseMenu} className="header__overlay" />}
                </div>
            </header>
        </>
    );
};

export default HeaderMobile;
